import React, { useState } from "react";
import "./login.css";
import { Redirect, RouteComponentProps } from "react-router-dom";
import {
  TextInput,
  TextInputMode,
} from "../../components/molecules/text-input";
import { useAuthState } from "../../auth";
import { Button } from "../../components/atoms/button/button";
import { Icon } from "../../components/atoms/icon";
import { Text } from "../../components/atoms/text";
import { NavigationHeader } from "../../components/molecules/navigation-header";

type LoginProps = {} & RouteComponentProps;

export const Login: React.FunctionComponent<LoginProps> = ({
  location,
}: LoginProps) => {
  const { isAuthenticated, login } = useAuthState();
  const [password, setPassword] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const { from } = (location.state as { from: string }) || {
    from: { pathname: "/" },
  };

  const onSubmit = React.useMemo(
    () => (e: React.FormEvent<HTMLFormElement>): void => {
      e.preventDefault();
      if (username && password) {
        login(username, password);
      }
    },
    [login, password, username]
  );

  const onUsernameChange = React.useMemo(
    () => (evt: React.ChangeEvent<HTMLInputElement>): void => {
      setUsername(evt.target.value);
    },
    [setUsername]
  );

  const onPasswordChange = React.useMemo(
    () => (evt: React.ChangeEvent<HTMLInputElement>): void => {
      setPassword(evt.currentTarget.value);
    },
    [setPassword]
  );

  if (isAuthenticated) {
    return <Redirect to={from} />;
  }

  return (
    <div className="Login">
      <NavigationHeader />
      <div className="Login-form">
        <div className="Information-container">
          <img src="images/laptop.png" className="laptop" alt="Laptop" />
          <Text align="left" className="Information-text">
            <b>Som kund hos oss</b> kan du se hur Mimboxen presterar i realtid
            och besparingar som görs.
          </Text>
        </div>
        <form onSubmit={onSubmit}>
          <TextInput
            label="Användarnamn"
            value={username}
            onChange={onUsernameChange}
          />
          <TextInput
            label="Lösenord"
            mode={TextInputMode.PASSWORD}
            value={password}
            onChange={onPasswordChange}
          />
          <Button className="Login-submit-button" type="submit">
            Logga in
          </Button>
        </form>
        <Icon className="fishes" type="fishes" size="xl" />
      </div>
    </div>
  );
};
